import { batch } from 'react-redux';
import { toast } from 'react-toastify';

import { useAppDispatch } from 'redux/store/store.types';
import { getApiErrorMessage } from 'utils';

import { useLazyFetchFeesQuery } from '../api/eecs-fees.api';
import { EecsFeesAC } from '../store/eecs-fees.slice';
import { FetchEecsFeesPayload } from '../types/eecs-fees.types';

interface UseEecsFees {
  clearEecsFeesState: () => void;
  fetchEecsFeesHandler: (payload: FetchEecsFeesPayload) => Promise<void>;
}

export const useEecsFees = (): UseEecsFees => {
  const dispatch = useAppDispatch();

  const [fetchFeesQuery] = useLazyFetchFeesQuery();

  const fetchEecsFeesHandler = async (payload: FetchEecsFeesPayload) => {
    dispatch(EecsFeesAC.toggleLoading(true));
    const { data: response, error } = await fetchFeesQuery(payload);
    dispatch(EecsFeesAC.toggleLoading(false));
    const isError = error || !response?.data;

    if (isError) {
      toast.error(getApiErrorMessage(error) || 'Failed to get Platform Fees!');
      return;
    }
    batch(() => {
      dispatch(EecsFeesAC.setItems(response.data));
      dispatch(EecsFeesAC.setPaginationMeta(response.meta));
    });
  };

  const clearEecsFeesState = () => {
    batch(() => {
      dispatch(EecsFeesAC.setCurrentPage(1));
      dispatch(EecsFeesAC.clearItems());
      dispatch(EecsFeesAC.clearFilters());
      dispatch(EecsFeesAC.clearSorts());
    });
  };

  return {
    clearEecsFeesState,
    fetchEecsFeesHandler,
  };
};
